<div class="fullcontainer">
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  @if (this.isSuccess) {
    <div class="alert alert-success">Vehicle VOR was updated successfully</div>
  }
  <div class='sheet'>
    <h1 class='header'>Edit Vehicle VOR - {{ this.vehicleVOR.vehicle.name }}</h1>
    <app-audit-line [data]='this.vehicleVOR'></app-audit-line>
    <form (ngSubmit)='this.onSubmit()' method='post'>
      <app-vehicle-vor-form [vehicleVOR]='this.vehicleVOR'></app-vehicle-vor-form>
      <button type="submit" class="btn btn-success">Save</button>&nbsp;
      <button type="button" class="btn btn-danger" routerLink='/vehicles/vor'>Cancel</button>
    </form>
  </div>
</div>
